<ngx-json-ld [json]='organizationSchema'></ngx-json-ld>

<hs-bugme [data]='bugme'></hs-bugme>

<nav class='navbar navbar-dark navbar-expand-sd header bugmebar' [class.bugme-margin]='bugme?.isVisible'>
  <div class='container-ld' id='container-ld-test'>
    <a class='logo-header' langLink='/'>
      <img alt='Royalty Free Music' title='HookSounds' src='/assets/home-images/hooksounds-logo-header.svg' width='289' height='36'>
    </a>
    <button class='navbar-toggler' type='button' (click)='menuCollapsed = !menuCollapsed' aria-controls='navbarContent'
            aria-expanded='false' aria-label='Toggle navigation'>
      <span class='navbar-toggler-icon'></span>
    </button>

    <div class='navbar-collapse' id='navbarContent' [hidden]='mobile && menuCollapsed || !utilsService.isBrowser'>

      <div class='form-inline search-bar ml-sd-5 mt-4 mt-sd-0'>
        <input class='form-control search' type='text' placeholder="{{ 'header.search-placeholder' | lang }}"
               attr.aria-label="{{ 'header.search-placeholder' | lang }}" (keydown.enter)='search($event.target.value)'>
      </div>

      <a class='search-button search ml-d-5 ml-sd-3' langLink='/royalty-free-music/'></a>

      <ul class='navbar-nav mr-auto align-items-start my-3 my-sd-0'>
        <li *ngIf='!userSubscribed' class='nav-item get-access ml-d-5 ml-sd-3 pl-3 pr-3 pl-sd-2 pr-sd-2'>
          <a class='nav-link' langLink='/premium/' (click)="gtag.click('get_full_access_cta')">
            {{ 'subscriptions.get-full-access' | lang }}
          </a>
        </li>
        <li class='nav-item ml-3 ml-sd-4 mx-2 mt-2 mt-sd-0'>
          <a class='nav-link' langLink='/royalty-free-music/' (click)="gtag.click('header_music')">
            <div>
              <img alt='Music note' title='Music' class='music-icon d-sd-inline-flex d-none' src='/assets/shared/music-white.svg'
                   loading='lazy'>
              {{ 'header.browse.music' | lang }}
            </div>
          </a>
        </li>
        <li class='nav-item  ml-3 mx-2 mt-2 mt-sd-0'>
          <a class='nav-link' langLink='/sound-effects/' (click)="gtag.click('header_sound_effects')">
            <div><img alt='Waveform' title='Sound effects' class='waveform-icon d-sd-inline-flex d-none' src='/assets/shared/waveform-white.svg'
                      loading='lazy'>
              {{ 'common.sound-effects' | lang }}
            </div>
          </a>
        </li>
        <li class='nav-item d-none d-d-inline-flex ml-3 mx-2 mt-2 mt-sd-0'>
          <div class='nav-link pipe bold'>|</div>
        </li>
        <li class='nav-item ml-3 mx-2 mt-2 mt-sd-0'>
          <a class='nav-link pink' langLink='/licensing/' (click)="gtag.click('header_licensing')">
            {{ 'common.licencing' | lang }}
          </a>
        </li>
        <li class='nav-item ml-3 mr-5 mx-2 mt-2 mt-sd-0'>
          <a class='nav-link pink' langLink='/blog/' (click)="gtag.click('header_blog')">
            {{ 'footer.company.blog' | lang }}
          </a>
        </li>
        <!-- <li class="nav-item mx-d-5 mx-2 mt-2 mt-sd-0">
            <a class="nav-link" (click)="editPage()">Open page editor</a>
          </li> -->
      </ul>

      <!-- Language menu -->
      <div class='nav-item d-none d-ld-flex dropdown ml-d-5 ml-2 mt-3 mt-sd-0' dropdown>
        <a class='nav-link dropdown-toggle language-toggle' href (click)='false' dropdownToggle
           aria-controls='lang-dropdown'>
          <ng-container *ngIf="locale.lang === 'en'">
            <img class='flag' alt='UK flag' src='/assets/home-images/uk-flag.svg' loading='lazy'>
            {{ "footer.languages.english" | lang }}
          </ng-container>

          <ng-container *ngIf="locale.lang === 'es'">
            <img class='flag' alt='Spain flag' src='/assets/home-images/spain-flag.svg' loading='lazy'>
            {{ "footer.languages.spanish" | lang }}
          </ng-container>

          <ng-container *ngIf="locale.lang === 'de'">
            <img class='flag' alt='Germany flag' src='/assets/home-images/germany-flag.svg' loading='lazy'>
            {{ "footer.languages.german" | lang }}
          </ng-container>

          <ng-container *ngIf="locale.lang === 'pt-br'">
            <img class='flag' alt='Brazil flag' src='/assets/home-images/brazil-flag.svg' loading='lazy'>
            {{ "footer.languages.portuguese" | lang }}
          </ng-container>
        </a>
        <div id='lang-dropdown' *dropdownMenu class='dropdown-menu'>
          <a [href]='seo.langUrls?.en ? seo.langUrls?.en : seo.fallbackLangUrls.en' class='dropdown-item'>
            <img class='flag' alt='UK flag' src='/assets/home-images/uk-flag.svg' loading='lazy'>
            {{ "footer.languages.english" | lang }}
          </a>
          <a [href]='seo.langUrls?.es ? seo.langUrls?.es : seo.fallbackLangUrls.es' class='dropdown-item'>
            <img class='flag' alt='Spain flag' src='/assets/home-images/spain-flag.svg' loading='lazy'> {{
            "footer.languages.spanish" |
              lang }}
          </a>
          <a [href]='seo.langUrls?.de ? seo.langUrls?.de : seo.fallbackLangUrls.de' class='dropdown-item'>
            <img class='flag' alt='Germany flag' src='/assets/home-images/germany-flag.svg' loading='lazy'>
            {{ "footer.languages.german" | lang }}
          </a>
          <a [href]="seo.langUrls && seo.langUrls['pt-br'] ? seo.langUrls['pt-br'] : seo.fallbackLangUrls['pt-br']" class='dropdown-item'>
            <img class='flag' alt='Brazil flag' src='/assets/home-images/brazil-flag.svg' loading='lazy'>
            {{ "footer.languages.portuguese" | lang }}
          </a>
        </div>
      </div>


      <!-- d-sd-none: for "SD" screen or more (small desktop) display: none -->
      <!-- d-d-inline-flex: for "D" screen or more (desktop) display: inline-flex -->
      <ul class='navbar-nav auth d-t-none d-d-inline-flex' *ngIf='!currentUser'>
        <li class='nav-item'>
          <a class='nav-link register' langLink='/join/'>{{ 'actions.register' | lang }}</a>
        </li>
        <li class='nav-item ml-d-4 ml-2'>
          <a class='nav-link login' langLink='/login/'>{{ 'actions.log-in' | lang }}</a>
        </li>
      </ul>

      <!-- d-none: display: none for all screen sizes -->
      <!-- d-sd-inline-flex: for "SD" screen or more display: inline-flex -->
      <!-- d-d-none: for "D" screen or more display: none -->
      <ul class='navbar-nav d-none d-t-inline-flex d-d-none' *ngIf='!currentUser'>
        <li class='nav-item dropdown ml-d-5 ml-sd-2' dropdown>
          <a class='nav-link' href (click)='false' dropdownToggle aria-controls='actions-dropdown'>
            <img alt='User' title='User' src='/assets/home-images/user.svg' loading='lazy' />
          </a>
          <div id='actions-dropdown' *dropdownMenu class='dropdown-menu dropdown-menu-right'>
            <a class='dropdown-item' langLink='/join/'>{{ 'actions.register' | lang }}</a>
            <a class='dropdown-item' langLink='/login/'>{{ 'actions.log-in' | lang }}</a>
          </div>
        </li>
      </ul>

      <ul class='navbar-nav auth' *ngIf='currentUser'>
        <li class='nav-item dropdown' dropdown>
          <a class='nav-link dropdown-toggle current-user' href (click)='false' id='navbarDropdown' role='button'
             aria-controls='user-dropdown' dropdownToggle>
            {{ headerDisplayName }}
          </a>
          <div id='user-dropdown' *dropdownMenu class='dropdown-menu dropdown-menu-right'
               aria-labelledby='navbarDropdown'>

            <a class='dropdown-item' langLink='/my-profile/user-profile/'>{{ 'common.profile' | lang }}</a>
            <a class='dropdown-item' langLink='/affiliate-profile/urls/'>{{ 'common.affiliate' | lang }}</a>
            <div class='dropdown-divider'></div>
            <div class='dropdown-item' (click)='logout()' lang>actions.log-out</div>
            <ng-container *ngIf='userAdmin || userEditor'>
              <div class='dropdown-divider'></div>
              <button class='dropdown-item' (click)='updateTranslations()'>Update translations</button>
              <button class='dropdown-item' (click)='clearApiCache()'>Clear WP API cache</button>
            </ng-container>
          </div>
        </li>
      </ul>

      <!--Cart popup experiment (browser only) -->
      <ng-container *ngIf='utilsService.isBrowser'>
        <ng-template #popupCartTemplate>
          <ng-container *ngIf='!showAddedToCart'>
            <div class='d-flex flex-row'>
              <div class='d-flex flex-column popup-cart'>
                <div class='popup-title'>{{ 'experiments.cart-popup-discount.title' | lang }}</div>
                <div class='d-flex flex-row'>
                  <div class='popup-check'>
                    <img alt='Checkmark' src='/assets/home-images/popup-check.svg' loading='lazy' />
                  </div>
                  <div class='popup-text'>{{ 'experiments.cart-popup-discount.discount-text' | lang }}</div>
                </div>
                <div>
                  <button class='btn btn-pink-small' (click)='goToCheckoutCartPopup()'>
                    {{ 'experiments.added-to-cart-popup.go-to-cart' | lang }}
                  </button>
                </div>
              </div>
              <div class='popup-close' (click)='closeCartPopup()'>
                <div class='popup-close-icon'></div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf='showAddedToCart'>
            <div class='d-flex flex-column'>
              <div class='d-flex flex-row'>
                <div class='popup-added-title'>{{'experiments.added-to-cart-popup.text'| lang:{ trackName: trackName } }}
                </div>
                <div class='popup-added-title close-popup' (click)='continueShopping()'>
                  x
                </div>
              </div>

              <div class='d-flex flex-row'>
                <div class='btn added-to-cart-button' (click)='goToCheckout()'>
                  {{ 'experiments.added-to-cart-popup.go-to-cart' | lang }}
                </div>
                <div class='btn added-to-cart-button' (click)='continueShopping()'>
                  {{ 'experiments.added-to-cart-popup.continue' | lang }}
                </div>
              </div>
            </div>

          </ng-container>
        </ng-template>

        <ul class='navbar-nav cart'>
          <li class='nav-item ml-d-4 ml-sd-2 ml-4'>
            <a class='nav-link' langLink='/checkout/' [popover]='popupCartTemplate' triggers='' #popupCart='bs-popover'
               placement='bottom right' container='body' [adaptivePosition]='true'>
              <img alt='Shopping cart' title='Cart' src='./assets/home-images/supermarket.svg' loading='lazy' width='21' height='19'>
              {{cart.totalItems}}
            </a>
          </li>
        </ul>
      </ng-container>
      <!-- Default cart button (without experiment, server only)-->
      <ng-container *ngIf='!utilsService.isBrowser'>
        <ul class='navbar-nav cart'>
          <li class='nav-item ml-d-4 ml-sd-2 ml-4'>
            <a class='nav-link' langLink='/checkout/'>
              <img alt='Shopping cart' title='Cart' src='./assets/home-images/supermarket.svg' loading='lazy' width='21' height='19'>
              {{cart.totalItems}}
            </a>
          </li>
        </ul>
      </ng-container>

    </div>
  </div>
</nav>


<router-outlet></router-outlet>

<div class='d-flex justify-content-end'>
  <button *ngIf="!chatService.loading" (click)='openChat()' class='chat-button' [class.playing]='isPlayerVisible()'
          aria-label='Support chat'></button>
  <button *ngIf="chatService.loading"  class='chat-button loading' [class.playing]='isPlayerVisible()'
          aria-label='Loading support chat'>
    <hs-spinny-spin [white]='true' size='2'></hs-spinny-spin>
  </button>
</div>


<!-- Footer -->
<footer class='page-footer footer'>
  <!-- Footer Links -->
  <div class='container-ld'>


    <!-- Grid row -->
    <div class='row' style='vertical-align: auto;'>

      <!-- Grid column -->
      <div class='col-sd-4'>
        <img alt='HookSounds logo' title='HookSounds logo' class='logo-footer' width='289' height='36'
             src='/assets/home-images/hooksounds-logo-header.svg' loading='lazy'>

        <p>{{ 'footer.sub-title' | lang:{ 'year': year } }}</p>

        <a class='phone' href="tel:{{ 'common.contact-phone' | lang }}">{{ 'common.contact-phone' | lang }}</a>


        <p class='mt-3'>{{ 'footer.connect-with-us' | lang }}</p>

        <a class='social' rel='”noopener”' href='https://twitter.com/HookSounds' target='_blank'>
          <img alt='Twitter' title='Twitter' src='/assets/shared/twitter.svg' loading='lazy' width='22' height='18'>
        </a>
        <a class='social' rel='”noopener”' href='https://www.facebook.com/HookSounds/' target='_blank'>
          <img alt='Facebook' title='Facebook' src='/assets/shared/facebook.svg' loading='lazy' width='10' height='22'>
        </a>
        <a class='social' rel='”noopener”' href='https://www.youtube.com/channel/UCwghrgZdUGTzjESP_ri0Itg' target='_blank'>
          <img alt='YouTube' title='YouTube' src='/assets/shared/youtube.svg' loading='lazy' width='22' height='22'>
        </a>
        <a class='social' rel='”noopener”' href='https://www.instagram.com/HookSounds/' target='_blank'>
          <img alt='Instagram' title='Instagram' src='/assets/shared/instagram.svg' loading='lazy' width='23' height='23'>
        </a>

      </div>

      <!-- Grid column -->
      <div class='col-sd col-6'>
        <!-- Links -->
        <h5 class='footer-title'>{{ 'footer.company.title' | lang }}</h5>
        <ul class='list-unstyled'>
          <li>
            <a class='link' langLink='/'>{{ 'footer.company.royalty-free-music' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/sound-effects'>{{ 'common.sound-effects' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/about'>{{ 'footer.company.about-us' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/licensing'>{{ 'common.licencing' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/privacy-policy'>{{ 'footer.company.privacy-policy' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/terms-of-service'>{{ 'footer.company.tos' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/{{ locale.getHelpSlug() }}'>{{ 'footer.company.help' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/blog'>{{ 'footer.company.blog' | lang }}</a>
          </li>
        </ul>

      </div>
      <!-- Grid column -->

      <!-- Grid column -->
      <div class='col-sd col-6'>
        <!-- Links -->
        <h5 class='footer-title'>{{ 'footer.plans.title' | lang }}</h5>

        <ul class='list-unstyled'>
          <li>
            <a class='link' langLink='/premium'>{{ 'subscriptions.premium' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/business'>{{ 'subscriptions.business' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/in-store-music'>{{ 'footer.plans.in-store-music' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/education'>{{ 'footer.plans.education-program' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/nonprofit'>{{ 'footer.plans.nonprofit-program' | lang }}</a>
          </li>
        </ul>


      </div>
      <!-- Grid column -->
      <div class='col-sd col-6'>
        <!-- Links -->
        <h5 class='footer-title'>{{ 'footer.become.title' | lang }}</h5>

        <ul class='list-unstyled'>
          <li>
            <a class='link' langLink='/affiliates'>{{ 'footer.become.affiliate' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/partnerships'>{{ 'footer.become.partner' | lang }}</a>
          </li>
          <li>
            <a class='link' langLink='/sponsorship-program'>{{ 'footer.become.sponsor' | lang }}</a>
          </li>
        </ul>

        <h5 class='footer-title'>{{ 'footer.contact.title' | lang }}</h5>
        <ul class='list-unstyled'>
          <li>
            <a class='link' langLink='/contact'>{{ 'actions.contact-us' | lang }}</a>
          </li>
        </ul>

      </div>


      <!-- Grid column -->
      <div class='col-sd col-6'>
        <!-- Links -->
        <h5 class='footer-title'>{{ 'footer.languages.title' | lang }}</h5>

        <ul class='list-unstyled'>
          <li>
            <a [href]='seo.langUrls?.en ? seo.langUrls?.en : seo.fallbackLangUrls.en' class='link'>
              <img alt='UK flag' class='flag' src='/assets/home-images/uk-flag.svg' loading='lazy' width='16' height='11'>
              {{ "footer.languages.english" | lang }}
            </a>
          </li>
          <li>
            <a [href]='seo.langUrls?.es ? seo.langUrls?.es : seo.fallbackLangUrls.es' class='link'>
              <img alt='Spain flag' title='Spanish' class='flag' src='/assets/home-images/spain-flag.svg'
                   loading='lazy' width='16' height='11'>
              {{ "footer.languages.spanish" | lang }}
            </a>
          </li>
          <li>
            <a [href]='seo.langUrls?.de ? seo.langUrls?.de : seo.fallbackLangUrls.de' class='link'>
              <img alt='Germany flag' title='German' class='flag' src='/assets/home-images/germany-flag.svg'
                   loading='lazy' width='16' height='11'>
              {{ "footer.languages.german" | lang }}
            </a>
          </li>
          <li>
            <a [href]="seo.langUrls && seo.langUrls['pt-br'] ? seo.langUrls['pt-br'] : seo.fallbackLangUrls['pt-br']" class='link'>
              <img alt='Brazil flag' title='Portuguese (Brazil)' class='flag' src='/assets/home-images/brazil-flag.svg'
                   loading='lazy' width='16' height='11'>
              {{ "footer.languages.portuguese" | lang }}
            </a>
          </li>
        </ul>

        <img alt='HookSounds Footer Logo' title='HookSounds Footer Logo' class='footer-logo'
             src='/assets/home-images/hooksounds-logo-footer.svg' loading='lazy' width='181' height='159'>

      </div>
      <!-- Grid column -->
    </div>
    <!-- Grid row -->
  </div>
  <!-- Footer Links -->
  <div class='border-top-copyright d-flex justify-content-center'>
    <div class='mt-3'>
      {{ 'footer.copyright' | lang:{ 'year': year } }}
    </div>
  </div>
</footer>
<!-- Footer -->

<hs-player *ngIf='includePlayer()' (collapsedChange)='collapse($event)' class='fixed-bottom'></hs-player>
